import React from 'react';
import { Reveal } from './Reveal';
const bonuses = [{
  title: 'Banco de Exámenes Express',
  description: 'Pruebas extra por tema con solucionario',
  price: '19 USD',
  image: 'https://cdn.magicpatterns.com/uploads/757CgQ3koCXZvoxbGLJ6QF/q1.webp'
}, {
  title: 'Planificador Docente Anual',
  description: 'Clases listas, cronograma y criterios de evaluación',
  price: '27 USD',
  image: 'https://cdn.magicpatterns.com/uploads/adkCCuzqiBVYQ6fiWmC5t3/q2.webp'
}, {
  title: 'Laboratorio en Casa',
  description: '20 experimentos con materiales caseros',
  price: '36 USD',
  image: 'https://cdn.magicpatterns.com/uploads/imD1QYQ4QdCNhccTFXsot9/q3.webp'
}, {
  title: 'Láminas de Aula',
  description: 'Tabla periódica, formulario y pósters de conceptos',
  price: '19 USD',
  image: 'https://cdn.magicpatterns.com/uploads/fzFRUY4gwgFa9Po8CyY4qN/q4.webp'
}, {
  title: 'Repaso Divertido',
  description: 'Juegos y actividades gamificadas para tus alumnos',
  price: '27 USD',
  image: 'https://cdn.magicpatterns.com/uploads/22ByUQBpieSPv7GX7v4E9V/q5.webp'
}];
export function BonusesSection() {
  return <section className="bg-brand-dark px-4 py-20 md:py-28" data-id="element-17" data-mp="2lm5r33vcel1">
      <Reveal className="mx-auto max-w-3xl" data-id="element-18" data-mp="2k1blelguxnp">
        <div className="mb-12 text-center" data-id="element-19" data-mp="7kfkeyuw6bms">
          <h2 className="text-3xl font-black text-brand-blue md:text-4xl" data-id="element-20" data-mp="7ma5cd65y3qv">🎁 5 bonos exclusivos</h2>
          <p className="mt-4 text-brand-gray" data-id="element-21" data-mp="cjac6qau7aj1">
            Valorados en <span className="font-bold text-brand-purple line-through" data-id="element-22" data-mp="gkvittws2sks">128 USD</span> — incluidos{' '}
            <strong className="text-brand-teal" data-id="element-23" data-mp="lblqxewl99j6">gratis por tiempo limitado</strong>
          </p>
        </div>
        <div className="space-y-3" data-id="element-24" data-mp="qbgg9e0ptr24">
          {bonuses.map((bonus, index) => <article key={bonus.title} className="flex items-center gap-4 rounded-2xl border border-brand-blue/[0.06] bg-brand-alt p-4 shadow-sm sm:gap-5" data-id="element-25" data-mp="vajikqpb9j6e" data-mpi={index}>
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand-blue font-serif font-bold text-white" data-id="element-26" data-mp="akz4tx22ouj6">
                {index + 1}
              </span>
              <img src={bonus.image} alt={`Portada de ${bonus.title}`} className="h-20 w-14 shrink-0 rounded-md border border-brand-dark object-cover shadow-sm sm:h-24 sm:w-[4.25rem]" data-id="element-27" data-mp="kas6o6cexva8" />
              <div className="min-w-0 flex-1" data-id="element-28" data-mp="tafd56k01ra5">
                <h3 className="font-bold leading-snug text-brand-blue" data-id="element-29" data-mp="ocnfrx0l5cyk">{bonus.title}</h3>
                <p className="mt-1 text-xs" data-id="element-30" data-mp="of018k5jy5gd">
                  <span className="text-brand-gray" data-id="element-31" data-mp="138v3367aiui2">{bonus.description}</span>
                  <span className="ml-2 font-semibold text-brand-purple line-through" data-id="element-32" data-mp="yaa234k7s6sk">antes {bonus.price}</span>
                  <span className="ml-2 font-extrabold text-brand-teal" data-id="element-33" data-mp="350hn2nsrlp51">GRATIS</span>
                </p>
              </div>
            </article>)}
        </div>
      </Reveal>
    </section>;
}